// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Link } from '@/components/link';
import { Project } from '@/project/api/types';
import { TypographyProps } from '@mui/material';

interface Props extends Pick<TypographyProps, 'variant'> {
  /**
   * A project to link to.
   */
  project: Pick<Project, 'key' | 'name'>;
}

/**
 * A link to a single project.
 */
export function ProjectLink(props: Props) {
  return (
    <Link
      to="/projects/$projectKey"
      variant={props.variant}
      params={{ projectKey: props.project.key }}
    >
      {props.project.name}
    </Link>
  );
}
